import React from 'react';

import { getSingleSelectedItemEntryOrNull } from '../../../../store/selectors/getSelectedItemSelector';
import {
  applicationOnPickingContinuousBearingLine,
  applicationOnPickingRegularBearingLine,
} from '../../../../store/slices/applicationSlice';
import { ReferenceLinePicker } from '../../../controls/ReferenceLinePicker';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export type LineRoleIdentifier = 'DefinitionLine' | 'BearingLine' | 'LeftSideLine' | 'RightSideLine';

export default ({
  label,
  elevation,
  propertyName,
}: {
  readonly label: string;
  readonly elevation?: number;
  readonly propertyName: 'bearingLineGuid' | 'lineGuid' | 'leftSideLineGuid' | 'rightSideLineGuid';
}) => {
  const dispatch = useAppDispatch();
  const selectedEntry = useAppSelector(getSingleSelectedItemEntryOrNull);
  if (selectedEntry?.type !== 'bearing') return null;
  const bearing = selectedEntry.item;

  const { relativeGeometry } = bearing;
  if (!relativeGeometry) {
    console.error('Relative geometry is not set correctly.');
    return null;
  }

  if (
    relativeGeometry.bearingGeometryType === 'ContinuousBearing' &&
    (propertyName === 'leftSideLineGuid' || propertyName === 'rightSideLineGuid' || propertyName === 'bearingLineGuid')
  ) {
    return (
      <ReferenceLinePicker
        elevation={elevation}
        label={label}
        lineGuid={relativeGeometry[propertyName]}
        startSelectLine={() =>
          dispatch(
            applicationOnPickingContinuousBearingLine({
              bearingGeometryType: 'ContinuousBearing',
              propertyName,
              bearingGuid: bearing.guid,
            }),
          )
        }
      />
    );
  }

  if (
    relativeGeometry.bearingGeometryType === 'Bearing' &&
    (propertyName === 'lineGuid' || propertyName === 'bearingLineGuid')
  ) {
    return (
      <ReferenceLinePicker
        elevation={elevation}
        label={label}
        lineGuid={relativeGeometry[propertyName]}
        startSelectLine={() =>
          dispatch(
            applicationOnPickingRegularBearingLine({
              bearingGeometryType: 'Bearing',
              propertyName,
              bearingGuid: bearing.guid,
            }),
          )
        }
      />
    );
  }

  throw new Error('Invalid bearing reference line picker configuration.');
};
